module.exports = __webpack_public_path__ + "img/get-map-geo__icon.a0fbf0d3.svg";